import { useMemo } from "react";
import { FACEBOOK_APP_ID } from '../../../types/const';
import { useTranslations } from '../../../utils/translations';

export const useFacebookShareURL = (doneeName: string, givingLink: string) => {
    const { post } = useTranslations('socialMediaGiving.facebook.page', {
        post: ['text'],
    });

    const facebookShareURL = useMemo(() => {
        const postContent =
            post.text.replace('{DONEE_NAME}', doneeName) + givingLink;

        return (
            `https://www.facebook.com/dialog/share?app_id=${FACEBOOK_APP_ID}&display=popup&quote=${postContent}&href=` +
            encodeURI(givingLink)
        );
    }, [doneeName, post.text, givingLink]);

    return facebookShareURL;
};